<app-analytics-risk [hideFilters]="hideFilters" [filters]="filters" [dashboardType]="dashboardType" [reportTabs]="reportTabs"></app-analytics-risk>
